var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.userEqui == 'pc')?_c('div',{staticClass:"MapBox"},[_c('div',{attrs:{"id":"allmap"}})]):_c('div',{staticClass:"MapBox",style:({ width: this.equiWidth, height: '300px' })},[_c('div',{attrs:{"id":"allmap"}})])
}
var staticRenderFns = []

export { render, staticRenderFns }